import React from 'react';
import useStore from '../../customHooks/useStore';

const EulaLink = () => {
  const { language } = useStore((state) => ({
    language: state.language,
    setLanguage: state.setLanguage,
  }));
  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={language === 'en' ? './EULA.pdf' : './Eula_Spanish.pdf'}
    >
      End User License Agreement
    </a>
  );
};

export default EulaLink;
